/* eslint-disable  */
/* eslint-disable react/prop-types */
/* eslint-disable import/no-unresolved */
/* eslint-disable global-require */
/* eslint-disable  */
// @ts-nocheck
import * as React from 'react';
import {
  Box,
  Grid,
  Typography,
  Button,
  IconButton,
  InputLabel,
  TextField,
  OutlinedInput,
  InputAdornment,
  FormControlLabel,
  Checkbox,
  FormHelperText,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import MainLogo from '../../../components/MainLogo/MainLogo.components';
import InfoIcon from '@mui/icons-material/Info';
import CloseIcon from '@mui/icons-material/Close';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { useLogin } from '../hooks/useLogin';

const SignUp = ({ handlePages }) => {
  // Start Input Password Code
  interface State {
    amount: string;
    password: string;
    weight: string;
    weightRange: string;
    showPassword: boolean;
  }
  const [values, setValues] = React.useState<State>({
    amount: '',
    password: '',
    weight: '',
    weightRange: '',
    showPassword: false,
  });
  const handleChange = (prop: keyof State) => (event: React.ChangeEvent<HTMLInputElement>) => {
    setValues({ ...values, [prop]: event.target.value });
  };
  const handleClickShowPassword = () => {
    setValues({
      ...values,
      showPassword: !values.showPassword,
    });
  };
  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  const { signUp } = useLogin();

  const validationSchema = yup.object({
    email: yup
      .string('Enter your email')
      .email('Enter a valid email')
      .required('Email is required'),
    password: yup
      .string('Enter your password')
      .min(8, 'Password should be of minimum 8 characters length')
      .required('Password is required'),
    fullName: yup.string('Enter your name').required('Name is required'),
    agreement: yup.boolean().oneOf([true], 'You must accept the terms and conditions'),
  });

  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
      fullName: '',
      agreement: false,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      const { agreement, ...rest } = values;
      signUp(rest, callBack);
    },
  });

  const callBack = () => {
    formik.resetForm();
    handlePages(0);
  };

  // End Input Password Code
  return (
    <form onSubmit={formik.handleSubmit}>
      <Grid>
        <Grid id="alert-dialog-description">
          <Box sx={{ mt: 2, mb: 3 }}>
            <Typography variant="h4" sx={{ mb: 1 }}>
              Sign up with email
            </Typography>
            <Typography variant="body2">Save and access your designs at any time</Typography>
          </Box>
          <Box className="CommonFormControl">
              <InputLabel>Name *</InputLabel>
              <TextField
                label=""
                variant="outlined"
                name="fullName"
                value={formik.values.fullName}
                onChange={formik.handleChange}
                error={formik.touched.fullName && Boolean(formik.errors.fullName)}
                helperText={formik.touched.fullName && formik.errors.fullName}
              />
            </Box>
          <Box className="CommonFormControl">
            <InputLabel>Email *</InputLabel>
            <TextField
              label=""
              variant="outlined"
              name="email"
              value={formik.values.email}
              onChange={formik.handleChange}
              error={formik.touched.email && Boolean(formik.errors.email)}
              helperText={formik.touched.email && formik.errors.email}
            />
          </Box>
          <Box className="CommonFormControl">
            <InputLabel className="PasswordLabelBox">
              Password * <span className="ForgotPassword">Minimum 8 characters</span>
            </InputLabel>
            <OutlinedInput
              id="outlined-adornment-password"
              name="password"
              type={values.showPassword ? 'text' : 'password'}
              value={formik.values.password}
              onChange={formik.handleChange}
              error={formik.touched.password && Boolean(formik.errors.password)}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {values.showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              }
              label="Password"
            />
            <FormHelperText
              error={formik.touched.password && formik.errors.password}
              id="accountId-error"
            >
              {formik.errors.password}
            </FormHelperText>
          </Box>
          <Box className="CommonFormControl">
            <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
              <FormControlLabel
                control={
                  <Checkbox
                    name="agreement"
                    value={formik.values.agreement}
                    onChange={formik.handleChange}
                  />
                }
                label=""
                labelPlacement="end"
                className="AgreeCheckbox"
              />
              <Typography variant="body2">
                Creating an account means you agree with our <a>Terms of Service</a> and{' '}
                <a>Privacy Policy</a>
              </Typography>
            </Box>
            <FormHelperText
              error={formik.touched.agreement && formik.errors.agreement}
              id="accountId-error"
            >
              {formik.errors.agreement}
            </FormHelperText>
          </Box>
          <Box>
            <Button
              className="CommonModalButton FullWidthButton"
              color="primary"
              variant="contained"
              type="submit"
            >
              Create Account
            </Button>
          </Box>
          <Box className="SignUpBox" sx={{ textAlign: 'center', mt: 3 }} onClick={callBack}>
            <Typography variant="body2">
              Already have an account? <a className="UnderLineLink">Sign in</a>
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </form>
  );
};

export default SignUp;
